export default {

	data() {
		return {
			editorSettings: {
				modules: {
					imageDropAndPaste: {
						handler: this.imageDropHandler
					},
					imageResize: {},
					magicUrl: true,
				},
			},
			customToolbar: [
				[{'header': [1, 2, 3, 4, 5, 6, false]}],
				['bold', 'italic', 'underline', 'strike'],        // toggled buttons
				['align', { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
				['blockquote', 'code-block'],
				[{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
				[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
				[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
				['link','image'],
				['clean'],
			],
		}
	},

	computed: {
		getWidth() {
			return (key) => {
				if(this.$refs[key]) {
					return this.$refs[key][0] ? this.$refs[key][0].$el.clientWidth - (this.$refs[key][0].$el.clientWidth * 30 / 100) + 'px' : ''
				}
		   } 
	   },
	},

	methods: {

		imageDropHandler(imageDataUrl, type, Editor) {
			this.optimizeDataURL(imageDataUrl).then((dataurl) => {
				const index = (Editor.getSelection() || {}).index || Editor.getLength()
				Editor.insertEmbed(index, 'image', dataurl, 'user')
			})
		},

		optimizeDataURL(data) {
			return new Promise((resolve) => {
				var img = document.createElement("img")
				img.src = data
				img.onload = () => {
					var canvas = document.createElement("canvas")
					var MAX_WIDTH = 600
					var MAX_HEIGHT = 600
					var width = img.width
					var height = img.height
					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width
							width = MAX_WIDTH
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height
							height = MAX_HEIGHT
						}
					}
					canvas.width = width
					canvas.height = height
					var ctx = canvas.getContext("2d")
					ctx.drawImage(img, 0, 0, width, height)
					resolve(canvas.toDataURL("image/jpeg"))
				}
			})
		},

		handleImageAdded(file, Editor, cursorLocation, resetUploader) {
			// Create a file reader
			var reader = new FileReader()
			// Set the image once loaded into file reader
			reader.onload = (e) =>
			{
				this.optimizeDataURL(e.target.result).then((dataurl) => {
					Editor.insertEmbed(cursorLocation, 'image', dataurl, 'user')
					resetUploader()
				})
			}
			// Load files into file reader
			reader.readAsDataURL(file)
		},

		getInitialAvatar(data, field) {
			if(field.item_text && data.item[field.item_text]) {
				return data.item[field.item_text].slice(0, 1).toUpperCase()
			} else if(data.item.text) {
				return data.item.text.slice(0, 1).toUpperCase()
			} else {
				return ''
			}
		},

        getIcon(item) {
            if(typeof item.icon !== 'undefined') {
                return item.icon
            }else if(item.extra_fields && typeof item.extra_fields == 'string' && JSON.parse(item.extra_fields).icon) {
                return JSON.parse(item.extra_fields).icon
            } else {
                return false
            }
        },

		getTextClass(item) {
			if(item == 'unsolved') return 'red--text' 
		},

		removeChip(item, field) {
			let index = -1
			if(typeof item.value !== 'undefined') {
				index = this.model[field.key].map((obj) => {return obj.value}).indexOf(item.value)
			} else {
				index = this.model[field.key].map((obj) => {return obj.id}).indexOf(item.id)
			}
			if (index >= 0) this.model[field.key].splice(index, 1)
		},

	},
}